import { Flex } from 'components/Flex/Flex';
import { Spacer } from 'components/Spacer/Spacer';
import React, { ReactElement, useContext } from 'react';
import { ZCDChangeIndicator } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import {
  QUARTERLY_LABEL,
  getLineChartQuarterOrMonthLabel,
} from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/AspectScoresLineChart/AspectScoresLineChart.helpers';
import { getChangeType } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/AspectScoresLineChart/Header/Header.helpers';
import { ScoreOverTimeByAreaContext } from 'contexts/ScoresOverTimeByAreaContext';
import styles from './Header.module.scss';

export const Header = (): ReactElement => {
  const { t: translate } = useTranslation();
  const { allAspectScoresWithDateRange, selectedAspectScore, selectedDateRange } =
    useContext(ScoreOverTimeByAreaContext);
  const currentAspectScoreIndex = allAspectScoresWithDateRange.findIndex(
    (aspectScore) =>
      aspectScore.startDate === selectedDateRange.startDate && aspectScore.endDate === selectedDateRange.endDate,
  );
  if (currentAspectScoreIndex === -1) {
    throw new Error(`Could not find current aspect score for Aspect "${selectedAspectScore.aspect_name}"`);
  }

  const currentAspectScoreValue = Math.round(allAspectScoresWithDateRange[currentAspectScoreIndex].overallAspectScore);
  let previousAspectScoreValue: number | undefined;
  if (currentAspectScoreIndex > 0) {
    previousAspectScoreValue = Math.round(allAspectScoresWithDateRange[currentAspectScoreIndex - 1].overallAspectScore);
  }

  const currentAspectScoreDateLabel = getLineChartQuarterOrMonthLabel(
    allAspectScoresWithDateRange[currentAspectScoreIndex].startDate,
    allAspectScoresWithDateRange[currentAspectScoreIndex].endDate,
  );
  const isQuarterly = currentAspectScoreDateLabel.startsWith(QUARTERLY_LABEL);
  const changeType = getChangeType(currentAspectScoreValue, previousAspectScoreValue);

  return (
    <Flex>
      <h3 className={styles.aspectScore}>{currentAspectScoreValue}%</h3>
      <Spacer customSize={12} orientation="horizontal" />
      <section>
        <h5 className={styles.aspectName}>{selectedAspectScore.aspect_name}</h5>
        {changeType && previousAspectScoreValue && (
          <Flex>
            <ZCDChangeIndicator
              isColorized
              percentage={Math.abs(previousAspectScoreValue - currentAspectScoreValue)}
              changeType={changeType}
            />
            <Spacer customSize={4} orientation="horizontal" />
            <p className={styles.comparisonText}>
              {translate(
                `widgetGenerator.widgets.scoresOverTimeByArea.lineChart.${
                  isQuarterly ? 'quarterlyComparisonText' : 'monthlyComparisonText'
                }`,
              )}
            </p>
          </Flex>
        )}
      </section>
    </Flex>
  );
};
